module.exports = __webpack_public_path__ + "static/media/photo-upload-icon.7a7d0a69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/single-sample-modal/photo-upload-icon.svg
// module id = 1634
// module chunks = 51